<template>
  <div class="layout">
  <Layout>
    <AdminTop />
    <Layout>
    <Sider hide-trigger :style="{background: '#fff'}">
    <AdminMenu />
  </Sider>
    <Layout :style="{padding: '0 24px 24px'}">
      <AdminBread />
      <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
        <FormItem label="关键词" prop="keyword">
          <Input v-model="formValidate.keyword" placeholder="输入关键词"></Input>
        </FormItem>

        <FormItem label="回复内容" prop="replyContent">
          <Input v-model="formValidate.replyContent" type="textarea" :autosize="false" :rows="5" placeholder="请输入回复内容"></Input>
        </FormItem>

        <!-- <FormItem label="排序" prop="weight">
          <Input v-model="formValidate.weight" ></Input>
        </FormItem> -->

        <FormItem>
          <Button type="primary" @click="handleSubmit('formValidate')">保存</Button>
        </FormItem>
      </Form>
      </Content>
    </Layout>
    </Layout>
  </Layout>
  <Modal v-model="modal" width="360">
    <template #header>
      <p style="color:#f60;text-align:left">
        <Icon type="ios-information-circle"></Icon>
        <span>成功</span>
      </p>
    </template>
    <div style="text-align:center">
      <p>内容添加成功，请您选择下一步操作。</p>
      <p>返回列表或继续添加</p>
    </div>
    <template #footer>
      <Row>
        <Col span="12" style="padding-right: 12px;"><Button type="info" size="large" long @click="gotoList">返回列表</Button></Col>
        <Col span="12" style="padding-left: 12px;"><Button type="warn" size="large" long @click="goonAdd">继续添加</Button></Col>
      </Row>
      
      
    </template>
  </Modal>
  </div>
</template>
<script>
import AdminTop from '../../components/AdminTop.vue'
import AdminMenu from '../../components/AdminMenu.vue'
import AdminBread from '../../components/AdminBread.vue'

import global from '@/utils/global'
import axios from 'axios'
export default {
  components: {
    AdminTop,
    AdminMenu,
    AdminBread
  },

  data () {
      return {
        user: null,

        modal: false,
        uploadUrl: global.restUrl + '/api/web/upload/v1.0/picture',
        formValidate: {
          keyword: '',
          replyContent: '',
          weight: 0,
        },
        ruleValidate: {
          keyword: [
            { required: true, message: '关键词不能为空', trigger: 'blur' },
            { type: 'string', min: 2, message: '关键词至少2个字', trigger: 'blur' }
          ],

          replyContent: [
            { required: true, message: '回复内容不能为空', trigger: 'blur' },
            { type: 'string', min: 10, message: '回复内容至少10个字', trigger: 'blur' }
          ],

          // weight: [
          //   { required: true, message: '排序不能为空', trigger: 'blur' },
          //   { type: 'number', min: 0, message: '排序只能是数字', trigger: 'blur' }
          // ],
        }
      }
    },
    mounted() {
    this.initUser()
  },
    methods: {
      //初始化用户信息
      initUser() {
        let userStr = localStorage.getItem("user")
        if(userStr!=null) {
          this.user = JSON.parse(userStr)
        } else {
          this.$router.push({path: '/'})
        }
      },

      handleSubmit (name) {
        let vm = this
        this.$refs[name].validate((valid) => {
          if (valid) {
            //console.log(this.formValidate)
            //this.$Message.success('Success!');
            axios({
              method: 'post',
              url: global.restUrl+'/api/manage/robot/v1.0/keyword/save',
              data: this.formValidate,
              headers:{
                token: vm.user.token
              }
          })
            .then(function (response) {
              let success = response.data.success
              if(success) {
                vm.modal = true
                 console.log(success)
              }
            })
            .catch(function (error) {
              console.log(error);
            });
          } else {
            this.$Message.error('数据校验失败');
          }
        })
      },
      handleReset (name) {
        this.$refs[name].resetFields();
      },

      //上传成功
      handleUpload(response) {
        if(response.errno==0) {
          this.formValidate.cover = response.data.url
        }
      },
      
      //文件移除
      handleRemove() {
        this.formValidate.cover = ''
      },

      //返回列表
      gotoList() {
        this.$router.push('/admin/keyword/all');
      },
      //继续添加
      goonAdd() {
        this.$refs['formValidate'].resetFields()
        this.modal = false
      }
    }
}
</script>
